// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductCustomiser{background:#FFFFFF;z-index:2}.ProductCustomiser__rows{margin:1rem 0 1.5rem;}@media (max-width: 799px){.ProductCustomiser__rows{margin-top:0}}@media (max-width: 799px){.ProductCustomiser__row{display:none}}.ProductCustomiser__row--hide-on-desktop{display:none}.ProductCustomiser__row--visible{display:block}.ProductCustomiser__iris-toggle{justify-content:flex-end;margin-top:0.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
